import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
import Chart, { ChartDataSets } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as CanvasJS from '../../../../supporter/CanvasJS.min.js';
import { BrdsqlService } from '../../../services/brdsql.service';
import { FormatService } from '../../../services/format.service';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatAccordion } from '@angular/material/expansion';
import * as echarts from 'echarts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserModule } from '@angular/platform-browser';
import { Color, Label } from 'ng2-charts';
import { EChartsOption } from 'echarts';
@Component({
  selector: 'app-executive',
  templateUrl: './executive.component.html',
  styleUrls: ['./executive.component.css']
})
export class ExecutiveComponent implements OnInit {
  chartInstances: echarts.ECharts[] = [];

  // KTD
  @ViewChild('barCanvas') barCanvas: ElementRef;
  @ViewChild(MatAccordion) accordion: MatAccordion;
  lastupdate = new Date()

  brdsummary?: any = [];
  canetypeData?: any = [];
  caneAssessnow: number;
  yieldNow: number;
  trendData?: any = [];

  ChartData?: any = [];
  ChartDataSets?: any = [];
  Label?: any = [];
  ChartOptions?: any = [];
  Color?: any = [];
  ChartLegend = false;
  ChartPlugins?: any = [];
  ChartType? = "";

  panelState = false;
  year_L = [    //รายการปี
    { "dataid": 3, "yearTh": "6566", "yearCr": "2223", "yearDesc": "ปี 2565/2566", "state": 0 },
    { "dataid": 4, "yearTh": "6667", "yearCr": "2324", "yearDesc": "ปี 2566/2567", "state": 0 },
    { "dataid": 5, "yearTh": "6768", "yearCr": "2425", "yearDesc": "ปี 2567/2568", "state": 0 },
    { "dataid": 6, "yearTh": "6869", "yearCr": "2526", "yearDesc": "ปี 2568/2569", "state": 0 },
    { "dataid": 7, "yearTh": "6970", "yearCr": "2627", "yearDesc": "ปี 2569/2570", "state": 1 },
  ]

  year_S: any = {};//ปีที่เลือก
  constructor(
    private brdservice: BrdsqlService
    , private spinner: NgxSpinnerService
    , private format: FormatService
  ) {

  }

  m_id = '';
  ngOnInit(): void {
    this.m_id = 'sv';
    let year = this.year_L.filter((el) => (el.state) == 1);
    //let year = this.year_L.filter((el) => (el.dataid) == 6);

    let d1: any = new Date(), d2: any = new Date();
    d1.setDate(d1.getDate() - 15);
    this.data_select.d1 = d1;
    this.data_select.d2 = d2;

    this.year_S = year[0];
    this.summaryBRD(year[0].yearCr);
    setTimeout(() => {
      this.LoadAPIall(year[0].yearTh);
    }, 100);

    //await this.test();
    /*await this.caneTypeDoughnutChart();
    await this.caneTypeAssessChart();
    await this.canetypeYieldlineChart();
    await this.levelPlotChart();   
    await this.caneTypeChart();
    */
  }

  chartInst_2() {
    const chartCon = document.getElementById('chart-pie-seedcane') as HTMLDivElement;
    const chartInst = echarts.init(chartCon);
    this.chartInstances.push(chartInst);
    window.addEventListener('resize', () => {
      chartInst.resize();
    });
  }

  reset_chart(id: string) {
    const chartContainer = document.getElementById(id);
    const myChart = echarts.init(chartContainer);
    if (myChart) {
      myChart.dispose();
    }
    //console.log('myChart:', myChart);
  }

  select_year() {
    let year = this.year_S;
    this.LoadAPIall(year.yearTh);
    this.summaryBRD(year.yearCr);
    console.log('year_S :', year);
    //console.log('year_S[01] :',year[0],year[1])    
  }

  tarAsNow: number;

  sum_brd?: any;
  to_sum(dd: string) {
    this.m_id = dd;
    let sb = { ...this.sum_brd };
    let bs = this.brdsummary;

    if (dd == 'sv') {
      bs.area = sb.area;
      bs.areaLost = sb.areaLost;
      bs.areaLeft = sb.areaLeft;
      bs.pc_area = sb.pc_area;
      bs.pc_areaLeft = sb.pc_areaLeft;
      bs.asNow = sb.asNow;
      bs.asLeft = sb.asLeft;
      bs.caneLost = sb.caneLost;
      bs.cutseed = sb.cutseed;
      bs.pc_asNow = sb.pc_asNow;
      bs.pc_asLeft = sb.pc_asLeft;
      bs.yieldNow = sb.yieldNow;
      bs.yieldLeft = sb.yieldLeft;
      bs.pc_yieldNow = sb.pc_yieldNow;
    }
    else if (dd == 'ld') {
      bs.area = sb.area_ld;
      bs.areaLost = sb.areaLost_ld;
      bs.areaLeft = sb.areaLeft_ld;
      bs.pc_area = sb.pc_area_ld;
      bs.pc_areaLeft = sb.pc_areaLeft_ld;
      bs.asNow = sb.asNow_ld;
      bs.asLeft = sb.asLeft_ld;
      bs.caneLost = sb.caneLost_ld;
      bs.cutseed = sb.cutseed_ld;
      bs.pc_asNow = sb.pc_asNow_ld;
      bs.pc_asLeft = sb.pc_asLeft_ld;
      bs.yieldNow = sb.yieldNow_ld;
      bs.yieldLeft = sb.yieldLeft_ld;
      bs.pc_yieldNow = sb.pc_yieldNow_ld;
    }
    else if (dd == 'ad') {

    }
    /*console.log('to_sum sb:', dd, sb);
    console.log('to_sum bs:', dd, bs);*/
  }

  // พื้นที่ปลูก
  async summaryBRD(year: string) {
    // console.log('summaryBRD()', year)
    let url1 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_sumTargetCane]&w=year=" + year;
    this.spinner.show()
    axios.get(url1).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        this.brdsummary = { ...data[0] };
        this.sum_brd = { ...data[0] };
        //let sugarcaneArea = this.brdsummary.area / 100000
      }
    }).catch(err => { throw (err) })
  }

  async monthOfArealevel(year: string) {
    let url3 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_monthOfArealevel_" + year + "]&w=1=1";
    await axios.get(url3).then(res => {
      let data = res.data;
      if (data.length > 0) {
        data = data.sort(function (a, b) { return a.cntMonth - b.cntMonth });
        this.ArealevelOMonth = data;
        setTimeout(() => {
          this.Load_ArealevelChartM();
        }, 500)
      }
      else {
        this.ArealevelOMonth = [];
        setTimeout(() => {
          this.Load_ArealevelChartM();
        }, 500)
      }
    }).catch(err => { throw (err) })
  }

  async Disease_Insect(year: string) {
    /* data_Disease , data_Insect*/
    let url4 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_Disease_Insect_" + year + "]&w=1=1";
    await axios.get(url4).then(res => {
      let data = res.data;
      if (data.length > 0) {
        this.data_Disease = data.filter(element => element.name == "d");
        this.data_Insect = data.filter(element => element.name == "i");
        setTimeout(() => {
          this.data_chart_di('d');
          this.data_chart_di('i');
        }, 100);
      }
      else {
        this.data_Disease = [];
        this.data_Insect = [];
        setTimeout(() => {
          this.data_chart_di('d');
          this.data_chart_di('i');
        }, 100);
      }
    }).catch(err => { throw (err) })
  }

  data_gradeYield_sub = [];
  data_gradeYield_sum = [];
  async gradeYield(year: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_gradeYield_" + year + "]&w=1=1";
    await axios.get(url).then(res => {
      let data = res.data;
      if (data.length > 0) {
        data.sort((b, a) => { return b.supzone - a.supzone; });
        this.data_gradeYield_sub = data.filter(el => el.supcode != 'sum');
        this.data_gradeYield_sum = data.filter(el => el.supcode == 'sum');
        //this.data_esp(6, 'All');
      }
    }).catch(err => { throw (err) })
  }
  call_gradeYield(zone: string) {
    setTimeout(() => {
      this.data_esp(6, zone);
    }, 200);
  }

  filter_data_grade(str: string): [] {
    let result: any;
    if (str == 'All') result = this.data_gradeYield_sub;
    else result = this.data_gradeYield_sub.filter(el => el.supzone == str);
    result.sort((b, a) => {
      if (a.pc_gA !== b.pc_gA) return a.pc_gA - b.pc_gA;
      else if (a.pc_gB !== b.pc_gB) return a.pc_gB - b.pc_gB;
      else return a.pc_gC - b.pc_gC;
    });
    return result;
  }

  KpiMn?: any = [];
  supcode_Kpi = ['all', '5'];
  supcode_Kpi_ls

  async Load_kpiActivity(year) {
    await this.brdservice.getKpiMonitor(year).subscribe({
      next: (res: any) => {
        let data = res;
        let sup = this.supcode_Kpi;
        if (data.length > 0) {
          //let supcode_list = data.map(function (el) { return el.supcode });
          let supcode_list = [...new Set(data.map(item => item.supcode))];
          this.supcode_Kpi_ls = supcode_list.sort();
          this.KpiMn = data;
          this.chartData = data.filter(el => el.supcode == sup[0]);
          this.Load_kpiActivity2(sup[0], sup[1]);
          console.log('supcode_list :', sup, this.supcode_Kpi_ls)
        }
      }
    })
  }

  async loadEstimateCaneData(year) {
    await this.brdservice.loadEstimateCaneData(year).subscribe({
      next: (res: any) => {
        let data = res;
        if (data.length > 0) {
          this.estimateCaneData = data;
          // console.log('reLoad_estimateCaneCharts estimateCaneData :', this.estimateCaneData)
          this.Load_estimateCaneChart();
        }
      }
    })
  }

  async getCpupdateData(year) {
    await this.brdservice.getCpupdateData(year).subscribe({
      next: (res: any) => {
        let data = res;
        if (data.length > 0) {
          data.sort((b, a) => a.yedate.localeCompare(b.yedate));
          this.cpupdateData = data;
          this.load_cpUpdateMontly();
        }
      }
    })
  }
  //********โหลด API********/,
  async LoadAPIall(year: string) {
    this.m_id = 'sv';
    await this.LoadsumCanetype(year);

    await this.Load_sum_informarea();

    // ข้อมูล กิจกรรมแปลง KPI ตามอายุอ้อย จาก v_kpiActivityMonitor_6667
    await this.Load_kpiActivity(year);

    // ข้อมูล การประเมินอ้อยในแต่ละครั้ง from v_Assess_xxxx
    //await this.loadEstimateCaneData(year);

    // ข้อมูลการอัพเดตกิจกรรมแปลง
    await this.getCpupdateData(year);

    await this.LoadsumCntFm(year);
    await this.monthOfArealevel(year);
    await this.gradeYield(year);
    await this.Disease_Insect(year);
    // ข้อมูลการอัพเดตกิจกรรมแปลงในแต่ละวัน ของเดือน
    await this.brdservice.getCpupdateDiaryData(year).subscribe({
      next: (res: any) => {
        let data = res;
        if (data.length > 0) {
          this.cpupdateDiaryData = data;
          // console.log('cpupdateDiaryData :' ,this.cpupdateDiaryData);
          this.load_cpupdateDiaryMonth();
        }
      }
    })

    // ข้อมูล สัดส่วนพันธุ์อ้อย
    await this.brdservice.loadSeedcaneRatioData(this.year_S.yearCr).subscribe({
      next: (res: any) => {
        let data = res;
        if (data.length > 0) {
          data.sort((a, b) => { return b.landvalue - a.landvalue });
          this.seedcaneRatioData = data;
          // console.log('res seedcaneRatioData :', this.seedcaneRatioData)
          setTimeout(() => {
            //this.load_seedcaneRatioChart();
            this.data_esp(4);
          }, 100);
        }
      }, complete() {
        // this.load_seedcaneRatioChart();
      },
    })

    await this.brdservice.getCpgroupQ(year).subscribe({
      next: (res: any) => {
        let data = res;
        if (data.length > 0) {
          this.cpgroupqdata = data
          setTimeout(() => {
            //this.drawCpq();
            this.data_esp(5);
          }, 100);
        }
      }, error(err) {
        alert('การเชื่อมต่อ api ผิดพลาด !!!!')
      }, complete() {
      }, closed
    })

    // ข้อมูล ประวัติอ้อยของ ฺBRR ในแต่ละปี
    /*await this.brdservice.getBrrsummary().subscribe({
      next: (res: any) => {
        let data = res;
        if (data.length > 0) {
          this.brrsummaryData = data
          console.log('brrsummaryData :', this.brrsummaryData);
          this.Load_brrModelCaneChart();
          this.load_xChart();
          this.load_yChart()
        }
      }, complete() {
        // alert('Load brrsummaryData successfuly...')
        // this.load_xChart();
      },
    })*/
    // ข้อมูลการจัดกลุ่มคิวแปลงอ้อย

  }

  sumCntFm = [];
  sumCntFmSum = [];
  sumBRD_canetype = [];
  sumBRD_canetypeAll: any;
  ArealevelOMonth = [];
  estimateCaneData?: any;
  seedcaneRatioData?: any;
  cpupdateData?: any;
  cpupdateDiaryData?: any;
  brrsummaryData?: any;
  cpgroupqdata?: any = [];
  data_Disease: any = [];
  data_Insect: any = [];

  data_esp(type: number, str = '') {
    var last_data, data, dataL, chart1, names, values, name_chart, name_c2: string, sum_all, id: string, radius = [];

    if (type > 0 && type <= 3) {
      data = this.sumBRD_canetype;
      dataL = this.sumBRD_canetypeAll;
      //console.log('dataL: ', dataL);
      id = 'chart-pie';
      names = data.map(function (elem) { return elem.CaneTypeName });
      name_c2 = ' แยกตามประเภทอ้อย ';
      radius = ['35%', '70%'];
      if (type == 1) {
        name_chart = ['พื้นที่ปลูก', ' ไร่'];
        values = data.map(function (elem) { return parseFloat(elem.area.toFixed(1)) });
        sum_all = parseFloat(dataL[0].area);
      }
      else if (type == 2) {
        name_chart = ['ปริมาณอ้อย', ' ตัน'];
        values = data.map(function (elem) { return parseFloat(elem.asNow.toFixed(1)) });
        sum_all = parseFloat(dataL[0].asNow);
      }
      else if (type == 3) {
        name_chart = ['ผลผลิต', ' ตัน/ไร่'];
        values = data.map(function (elem) { return parseFloat(elem.yieldNow.toFixed(2)) });
        sum_all = parseFloat(dataL[0].yieldNow);
      }
      //chart = document.getElementById('chart-pie') as HTMLDivElement;
      //chart = echarts.init(document.getElementById('chart-pie') as HTMLDivElement);
      last_data = names.map((value, i) => ({
        name: value,
        value: values[i]
      }));
    }
    else if (type == 4) {
      data = this.seedcaneRatioData;
      dataL = this.sumBRD_canetypeAll;
      names = data.map(function (elem) { return elem.seedname });
      name_c2 = ' แยกพันธุ์อ้อย ';
      id = 'chart-pie-seedcane';
      name_chart = ['สัดส่วนพันธุ์อ้อย ', ' ไร่'];
      radius = ['30%', '70%'];
      values = data.map(function (elem) { return parseFloat(elem.landvalue.toFixed(2)) });
      sum_all = parseFloat(dataL[0].area);
      window.addEventListener('resize', () => {
        chart1.resize();
      });
      last_data = names.map((value, i) => ({
        name: value,
        value: values[i]
      }));
    }
    else if (type == 5) {
      data = this.cpgroupqdata;
      dataL = this.sumBRD_canetypeAll;
      names = data.map(function (elem) { return elem.qdesc });
      name_c2 = ' จัดกลุ่ม ';
      id = 'chart-pie-groupQ';
      name_chart = ['ประเภทคิวอ้อย ', ' ตัน'];
      radius = ['30%', '70%'];
      values = data.map(function (elem) { return parseFloat(elem.assess.toFixed(1)) });
      sum_all = parseFloat(dataL[0].asNow);
      window.addEventListener('resize', () => {
        chart1.resize();
      });
      last_data = names.map((value, i) => ({
        name: value,
        value: values[i]
      }));
    }
    else if (type == 6) {
      dataL = this.data_gradeYield_sum.filter(el => el.supzone == str)[0];
      name_c2 = `เกรดแปลง โซน: ${str} `;
      id = 'chart-pie-chart_grade';
      name_chart = ['', ' ไร่'];
      radius = ['5%', '70%'];
      window.addEventListener('resize', () => {
        chart1.resize();
      });
      //console.log('data_chart_grade:', dataL);
      sum_all = parseFloat(dataL.landvalue);
      last_data = [
        { value: dataL.gA_area, name: 'เกรด: A ' },
        { value: dataL.gB_area, name: 'เกรด: B ' },
        { value: dataL.gC_area, name: 'เกรด: C ' },
      ];
    }
    console.log('last_data: ', type, last_data);
    this.reset_chart(id);
    chart1 = echarts.init(document.getElementById(id));

    const options = {
      title: [
        {
          text: name_chart[0] + name_c2 + this.year_S.yearTh,
          left: 'center',
          top: '1%',
        },
        {
          subtext: name_chart[0] + ' รวม: ' + sum_all.toLocaleString() + name_chart[1],
          top: '90%',
          left: '50%',
          textAlign: 'center',
          subtextStyle: {
            fontWeight: 'bold',
            fontSize: 14,
          }
        }
      ],
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          var value = params.value.toLocaleString('th-TH');
          var percent = params.percent.toLocaleString('th-TH');
          return `${params.seriesName} <br/>${params.name}: ${value} ${name_chart[1]}  (${percent}%)`;
        }
      },
      toolbox: {
        orient: 'horizontal',
        feature: {
          dataView: { show: true, readOnly: false },
          saveAsImage: { show: true }
        }
      },
      legend: {
        top: '6%',
        left: 'center'
      },
      series: [
        {
          name: name_chart[0],
          type: 'pie',
          center: ['50%', '55%'],
          radius: radius,
          itemStyle: {
            borderRadius: 6,
            borderColor: '#fff',
            borderWidth: 1
          },
          label: {
            show: true,
            alignTo: 'none',
            edgeDistance: 20,
            backgroundColor: '#F6F8FC',
            borderColor: '#8C8D8E',
            borderWidth: 1,
            borderRadius: 3,
            //formatter: '  {b|{b}：}{per| {c} ' + name_chart[1] + ' } {d}%  ',
            formatter: function (params) {
              // Convert the value to Thai locale format
              var formattedValue = params.value.toLocaleString('th-TH');
              return ` {b| ${params.name} ：} {per|${formattedValue} ${name_chart[1]}} - {per|${params.percent} %} `;
            },
            rich: {
              b: {
                color: '#4C5058',
                fontSize: 15,
                fontWeight: 'bold',
                lineHeight: 33
              },
              c: {
                fontSize: 16,
                fontWeight: 'bold',
                lineHeight: 33,
              },
              per: {
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [3, 4],
                borderRadius: 4,
              }
            }
          },
          data: last_data,
          emphasis: {
            itemStyle: {
              shadowBlur: 15,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
    //chart.setOption(options);    
    chart1.setOption(options);

  }


  data_chart_di(type: string) {
    var data, dataL, all_p, sum_all, chart, name_chart, name_c2, id = '';
    let last_data = [], sum_group = [];
    dataL = this.sumBRD_canetypeAll;
    sum_all = parseFloat(dataL[0].area);
    if (type == 'd') {
      name_chart = ['โรค', 'ไร่'];
      data = this.data_Disease;
      id = 'chart-pie-Disease';
    }//.filter(element => element.code != 0)
    else if (type == 'i') {
      name_chart = ['แมลง', 'ไร่'];
      data = this.data_Insect;
      id = 'chart-pie-Insect';
    }
    all_p = [...new Set(data.map(function (elem) { return (elem.p0) }))];
    //console.log('all_p:', all_p);
    for (var i = 0; i < all_p.length; i++) {
      last_data[i] = data.filter(element => element.code != 0 && element.p0 == all_p[i]).map((item) => {
        return {
          name: item.desc,
          value: item.landvalue
        };
      });
      sum_group[i] = last_data[i].reduce((ac, current) => ac + current.value, 0).toFixed(1);
      //console.log('last_data:', i, last_data[i]);
    }
    this.reset_chart(id);
    chart = echarts.init(document.getElementById(id));

    const option = {
      toolbox: {
        orient: 'horizontal',
        feature: {
          dataView: { show: true, readOnly: false },
          saveAsImage: { show: true }
        }
      },
      legend: {
        top: '7%',
        left: 'center'
      },
      tooltip: {
        formatter: function (params) {
          var value = params.value.toLocaleString('th-TH');
          var percent = params.percent.toLocaleString('th-TH');
          return `${params.seriesName} <br/>${params.name}: ${value} ${name_chart[1]}  (${percent}%)`;
        }
      },
      title: [
        {
          text: 'พบ:' + name_chart[0],
          left: 'center',
          top: '1%',
        },
        {
          subtext: 'กิจกรรมงวดที่ ' + all_p[0],
          left: '25%',
          top: '45%',
          textAlign: 'center',
          subtextStyle: {
            fontWeight: 'bold',
            fontSize: 14,
          }
        },
        {//subtext2
          subtext: `พื้นที่พบ ${name_chart[0]}  : ${(sum_group[0]).toLocaleString()}  ไร่ คิดเป็น ${((sum_group[0] * 100) / sum_all).toLocaleString()} % ของพื้นที่ทั้งหมด`,
          left: '25%',
          top: '48.5%',
          textAlign: 'center',

        },
        {
          subtext: 'กิจกรรมงวดที่ ' + all_p[1],
          left: '75%',
          top: '45%',
          textAlign: 'center',
          subtextStyle: {
            fontWeight: 'bold',
            fontSize: 14,
          }
        },
        {//subtext2
          subtext: `พื้นที่พบ ${name_chart[0]}  : ${(sum_group[1]).toLocaleString('th-TH')}  ไร่ คิดเป็น ${((sum_group[1] * 100) / sum_all).toLocaleString()} % ของพื้นที่ทั้งหมด`,
          left: '75%',
          top: '48.5%',
          textAlign: 'center',
        },
        {
          subtext: 'กิจกรรมงวดที่ ' + all_p[2],
          left: '25%',
          top: '90%',
          textAlign: 'center',
          subtextStyle: {
            fontWeight: 'bold',
            fontSize: 14,
          }
        },
        {//subtext2
          subtext: `พื้นที่พบ ${name_chart[0]}  : ${(sum_group[2]).toLocaleString('th-TH')}  ไร่ คิดเป็น ${((sum_group[2] * 100) / sum_all).toLocaleString()} % ของพื้นที่ทั้งหมด`,
          left: '25%',
          top: '93.5%',
          textAlign: 'center',
        },
        {
          subtext: 'กิจกรรมงวดที่ ' + all_p[3],
          left: '75%',
          top: '90%',
          textAlign: 'center',
          subtextStyle: {
            fontWeight: 'bold',
            fontSize: 14,
          }
        },
        {//subtext2
          subtext: `พื้นที่พบ ${name_chart[0]}  : ${(sum_group[3]).toLocaleString('th-TH')}  ไร่ คิดเป็น ${((sum_group[3] * 100) / sum_all).toLocaleString()} % ของพื้นที่ทั้งหมด`,
          left: '75%',
          top: '93.5%',
          textAlign: 'center',
        }
      ],
      series: [
        {
          type: 'pie',
          radius: ['7%', '25%'],
          center: ['25%', '30%'],
          data: last_data[0],
          label: {
            position: 'outer',
            bleedMargin: 5
          },
          itemStyle: {
            borderRadius: 6,
            borderColor: '#fff',
            borderWidth: 2
          },
        },
        {
          type: 'pie',
          radius: ['7%', '25%'],
          center: ['75%', '30%'],
          data: last_data[1],
          label: {
            position: 'outer',
            bleedMargin: 5
          },
          itemStyle: {
            borderRadius: 6,
            borderColor: '#fff',
            borderWidth: 2
          },
        },
        {
          type: 'pie',
          radius: ['7%', '25%'],
          center: ['25%', '75%'],
          data: last_data[2],
          label: {
            position: 'outer',
            margin: 20
          },
          itemStyle: {
            borderRadius: 6,
            borderColor: '#fff',
            borderWidth: 2
          },
        },
        {
          type: 'pie',
          radius: ['7%', '25%'],
          center: ['75%', '75%'],
          data: last_data[3],
          label: {
            position: 'outer',
            margin: 20
          },
          itemStyle: {
            borderRadius: 6,
            borderColor: '#fff',
            borderWidth: 2
          },
        }
      ]
    };
    chart.setOption(option);
    /*if (type == 'd') {      
      //chart1.setOption(options);
    }
    else if (type == 'i') {
      //this.chartInstances[2].setOption(options);
    }*/
  }

  async Stacked_Line(type: number) {
    var data = [], last_data = [], chart, name = [], id = ''
    if (type == 1) {//
      data = this.data_Line.Assess_data;
      name = ['ปริมาณอ้อย ', 'จำนวนชาวไร่ ', ''];
      id = 'chart-pie-Assess-fm';
    }
    else if (type == 2) {//
      data = this.data_Line.yield_data;
      name = ['ผลผลิต ', 'จำนวนชาวไร่ ', 'จำนวนแปลง'];
      id = 'chart-pie-yield-fm';
    }
    else if (type == 3) {//
      data = this.data_Line.area_data;
      name = ['พื้นที่ปลูก ', 'จำนวนชาวไร่ ', ''];
      id = 'chart-pie-area-fm';
    }
    else if (type == 4) {//เกรดชาวไร่
      data = this.data_Line.grade_data;
      name = ['เกรดชาวไร่ ', 'จำนวนชาวไร่ ', ''];
      id = 'chart-pie-grade-fm';
    }

    console.log('last_data: ', data);
    this.reset_chart(id);
    setTimeout(() => {
      chart = echarts.init(document.getElementById(id));
      chart.setOption(option);
    }, 100);

    const option = {
      title: {
        text: name[0]
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          var value = params.value.toLocaleString('th-TH');
          var percent = params.percent.toLocaleString('th-TH');
          return `${params.seriesName} <br/>${params.name}: ${value} (${percent}%)`;
        }
      },
      legend: {},
      grid: {
        left: '0',
        right: '0',
        bottom: '2%',
        containLabel: true
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: data[0],
        axisLabel: {
          interval: 'auto',
          fontSize: 14,
          rotate: 30
        },
      },
      yAxis: {
        type: 'value'
      },
      label: {
        show: true,
        position: 'top'
      },
      series: [
        { name: name[1], type: 'line', data: data[1] },
        { name: name[2], type: 'line', data: data[2] }
      ]
    };

  }


  async LoadsumCanetype(year: string) {
    let url1 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_sumCanetype" + year + "]&w=1=1";
    this.spinner.show()
    await axios.get(url1).then(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        let data0 = res.data
        this.sumBRD_canetype = data0.filter(element => element.canetype != "sum");
        this.sumBRD_canetype.sort(function (a, b) { return a.dataid - b.dataid });
        this.sumBRD_canetypeAll = data0.filter(element => element.canetype == "sum");
        // console.log('sumBRD_canetype:', this.sumBRD_canetype)
        this.data_esp(1);//
      }
      else {
        this.sumBRD_canetype = [];
        this.sumBRD_canetypeAll = [];
        this.data_esp(1);//

      }
    }).catch(err => { throw (err) })
  }

  getPercentage(value: number, sum: number) {
    return ((value / sum) * 100).toFixed(2);
  }

  date2en(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  sum_inform: any[] = [];
  list_p: any[] = [];
  data_select = { d1: '', d2: '' }
  informarea_Chart: EChartsOption = {};
  async Load_sum_informarea() {
    let year = this.year_S.yearTh;
    let data_s = this.data_select;
    let date1 = this.date2en(data_s.d1);
    let date2 = this.date2en(data_s.d2);
    const info = year >= 6970 ? 'v_informarea' : 'vw_informarea';
    const txdate = year >= 6970 ? 'created_at' : 'lastupdate';

    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[dbTemp].[dbo].[${info}${year}]&w=cast(${txdate} as date)between'${date1}'and'${date2}'and([Partcode]='BRD'or[supcode]<>'Z')order by[${txdate}]`;
    await axios.get(url).then(res => {
      let data = res.data;
      let list = [...new Set(data.map(item => item.Partcode))].sort();
      this.list_p = list;
      //console.log('list informarea:', list);

      this.sum_inform = data;
      this.cra_informarea_Chart('BRD')
      //console.log('sum_informarea:', data)
    }).catch(err => { throw (err) })
  }

  informarea_Charts: { [key: string]: EChartsOption } = {};
  list_supcode: any[] = [];
  cra_informarea_Chart(Partcodes: string) {

    // ใช้ Partcode แรกเพื่อดึงข้อมูล supcode ทั้งหมด
    const data = this.sum_inform.filter(el => el.Partcode == Partcodes);
    let list_supcode = [...new Set(data.map(item => item.supcode))].sort();
    this.list_supcode = list_supcode;
    console.log(data, 'list_sv_informarea:', list_supcode);

    this.informarea_Charts = {};
    list_supcode.forEach(supcode => {
      const supcodeData = data.filter(el => el.supcode == supcode);
      const label = supcodeData.map((el: any) => { return this.date2en(el.lastupdate) });
      const Assess = supcodeData.map((el: any) => { return el.Assess_left });
      const sYield = supcodeData.map((el: any) => { return el.sumYield });
      const legend_crop_loss = ['ปริมาณตัน', 'Yield'];
      this.informarea_Charts[supcode] = {
        title: {
          text: 'สรุปประเมินรายวัน ' + supcode, left: 'center',
        },
        tooltip: {
          trigger: 'axis', axisPointer: { type: 'shadow', },
        },
        legend: { data: legend_crop_loss, top: '6%', },
        xAxis: { type: 'category', data: label, axisLabel: { interval: 'auto', rotate: 30 }, },
        yAxis: [
          {
            type: 'value', name: legend_crop_loss[0], alignTicks: true,
            axisLine: { show: true, }, /*min: 1600000,*/
            position: 'left',
            offset: 0
          },
          {
            type: 'value', name: legend_crop_loss[1], position: 'right',
            axisLabel: { formatter: '{value}', }, /*min: 6,*/
            offset: 0
          }
        ],
        series: [
          {
            name: legend_crop_loss[0], data: Assess, type: 'bar',
            label: { show: true, position: 'top', formatter: (params: any) => new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(params.value), },
          },
          {
            name: 'Yield', data: sYield, type: 'line', yAxisIndex: 1,
            label: { show: true, position: 'top', formatter: '{c}', },
            lineStyle: { color: '#EE6666', }, itemStyle: { color: '#EE6666', },
          },
        ],
      };
    });
  }

  //data_grade = [];
  data_Line = { Assess_data: [], yield_data: [], area_data: [], grade_data: [] };
  async LoadsumCntFm(year: string) {
    //console.log('LoadAPIall()', this.ArealevelOMonth.length);    
    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_sumCntFm" + year + "]&w=1=1";
    this.spinner.show()
    await axios.get(url2).then(res => {
      this.spinner.hide();
      let data = res.data;
      if (data.length > 0) {
        this.sumCntFm = data;
        this.sumCntFmSum = data//.filter(element => element.SUPZONE == "sum");
        // เมื่อได้ข้อมูลจำนวนชาวไร่มาแล้ว โหลดกราฟ

        this.data_Line.Assess_data = [
          ['>=10,000', '5,000-10,000', '2,000-5,000', '1,000-2,000', '500-1,000', '200-500', '100-200', '<100'],
          [data[0].Assess1, data[0].Assess2, data[0].Assess3, data[0].Assess4, data[0].Assess5, data[0].Assess6, data[0].Assess7, data[0].Assess8]
        ]
        this.data_Line.yield_data = [
          ['>=18', '16-18', '14-16', '12-14', '10-12', '<10',],
          [data[0].yield1, data[0].yield2, data[0].yield3, data[0].yield4, data[0].yield5, data[0].yield6],
          [data[0].pyield1, data[0].pyield2, data[0].pyield3, data[0].pyield4, data[0].pyield5, data[0].pyield6],
        ]
        this.data_Line.area_data = [
          ['>=500', '300-500', '100-300', '50-100', '20-50', '10-20', '<10'],
          [data[0].area1, data[0].area2, data[0].area3, data[0].area4, data[0].area5, data[0].area6, data[0].area7]
        ]
        this.data_Line.grade_data = [
          ['เกรด A', 'เกรด B', 'เกรด C', 'เกรด D',],
          [data[0].grade_A, data[0].grade_B, data[0].grade_C, data[0].grade_D,]
        ]
        //this.data_grade = grade_data;
        setTimeout(async () => {
          await this.Stacked_Line(1);
          await this.Stacked_Line(2);
          await this.Stacked_Line(3);
          await this.Stacked_Line(4);
        }, 400)
        //console.log('sumCntFm:', this.sumCntFm)
        console.log('sumCntFmSum:', this.sumCntFmSum)
      }
      else {
        this.sumCntFm = [];
        this.sumCntFmSum = [];
      }
    }).catch(err => { throw (err) })
  }

  ArealevelChartM: any = [];
  async Load_ArealevelChartM() {
    let data = this.ArealevelOMonth;
    let cntMonthD = data.map(function (elem) { return elem.cntMonthD });
    let cnt = data.map(function (elem) { return elem.cnt });
    let av1 = data.map(function (elem) { return elem.av1 });
    let av2 = data.map(function (elem) { return elem.av2 });
    let av3 = data.map(function (elem) { return elem.av3 });
    let av4 = data.map(function (elem) { return elem.av4 });
    let av5 = data.map(function (elem) { return elem.av5 });

    this.ArealevelChartM = new Chart('ArealevelChartM', { // สร้าง object และใช้ชื่อ id lineChart ในการอ้างอิงเพื่อนำมาเเสดงผล
      //type: 'horizontalBar', // ใช้ชนิดแผนภูมิแบบเส้นสามารถเปลี่ยนชิดได้
      type: 'bar', // ใช้ชนิดแผนภูมิแบบเส้นสามารถเปลี่ยนชิดได้

      data: { // ข้อมูลภายในแผนภูมิแบบเส้น
        labels: cntMonthD, // ชื่อของข้อมูลในแนวแกน x
        datasets: [
          { // กำหนดค่าข้อมูลภายในแผนภูมิแบบเส้น
            label: 'พื้นที่สูงมาก',
            data: av5,
            datalabels: { align: 'top', offset: 10 },
            fill: true,
            backgroundColor: "#fe00f6",// 
            borderWidth: 1
          },
          { // กำหนดค่าข้อมูลภายในแผนภูมิแบบเส้น
            label: 'พื้นที่สูง',
            data: av4,
            datalabels: {
              align: 'top',
              offset: 10
            },
            fill: true,
            backgroundColor: "#011efe",// 
            borderWidth: 1
          },
          { // กำหนดค่าข้อมูลภายในแผนภูมิแบบเส้น
            label: 'พื้นที่เหมาะสม',
            data: av3,
            datalabels: { align: 'top', offset: 10 },
            fill: true,
            backgroundColor: "#0bff01",// 
            borderWidth: 1
          },
          { // กำหนดค่าข้อมูลภายในแผนภูมิแบบเส้น
            label: 'พื้นที่ลุ่ม',
            data: av2,
            datalabels: { align: 'top', offset: 10 },
            fill: true,
            backgroundColor: "#fdfe02",// 
            borderWidth: 1
          },
          { // กำหนดค่าข้อมูลภายในแผนภูมิแบบเส้น
            label: 'พื้นที่ลุ่มมาก',
            data: av1,
            datalabels: { align: 'top', offset: 10 },
            fill: true,
            backgroundColor: "#fe0000",// 
            borderWidth: 1
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return value.toLocaleString()
            },
            color: '#fff',
            backgroundColor: '#404040',
            //anchor:'end'          
          },
        },
        maintainAspectRatio: false,
        title: { // ข้อความที่อยู่ด้านบนของแผนภูมิ
          text: "อายุอ้อยในแต่ละระดับพื้นที่ " + this.year_S.yearTh,
          display: true,
          fontSize: 20,
        }
        , scales: {}
      }
    })
  }

  // KTD ++++++++++++++++++++++++++++++++++++++++++++
  chartData?: any = []
  plotTarget?: number;
  barChart: any;

  // กราฟ กิจกรรมแปลง kpi ตามอายุอ้อย 
  typeChart: any;
  dataChart: any;
  optionsChart: any;

  async Load_kpiActivity2(sup: string, id: string) {
    this.supcode_Kpi = [sup, id];

    let sum: number = 0;
    let data = this.KpiMn.filter(el => el.supcode == sup);
    data.forEach(item => {
      if (item.caneageid !== "5") {
        sum += item.cnt
      }
    });
    // this.plotTarget = sum;  // เป้าหมายแปลง
    this.typeChart = 'bar';
    let target = sum / 2;
    let pcplot
    let chartTitle = ''

    let datas = data.filter(el => el.caneageid == id)
    switch (id) {
      case '1': chartTitle = "กิจกรรมหลัก อ้อยอายุ 0-30 วัน"
        break;
      case '2': chartTitle = "กิจกรรมหลัก อ้อยอายุ 31-60 วัน"
        break;
      case '3': chartTitle = "กิจกรรมหลัก อ้อยอายุ 61-90 วัน"
        break;
      case '4': chartTitle = "กิจกรรมหลัก อ้อยอายุ > 90 วัน"
        break;
      case '5': chartTitle = "กิจกรรมหลัก ทั้งหมด"
        break;
      default: chartTitle = "กิจกรรมหลัก ทั้งหมด"
        break;
    }
    let ifnull = [0, 0, 0, 0, 0, 0, 0]
    let datasets = [];
    let datasets_l = [];
    let datasets_ll = [];
    if (datas.length > 0) {
      chartTitle = `${chartTitle} จำนวน ${datas[0].cnt.toLocaleString()} ไร่ `;
      datasets = [datas[0].cnt, datas[0].cnt, datas[0].cnt, datas[0].cnt, datas[0].cnt, datas[0].cnt, datas[0].cnt];
      datasets_l = [datas[0].pccane95, datas[0].hardsoilblast, datas[0].dolomite, datas[0].organic, datas[0].fertilizer1, datas[0].fertilizer2, datas[0].lastweed]
      datasets_ll = [
        Math.floor(((datas[0].pccane95 * 100) / datas[0].cnt)),
        Math.floor(((datas[0].hardsoilblast * 100) / datas[0].cnt)),
        Math.floor(((datas[0].dolomite * 100) / datas[0].cnt)),
        Math.floor(((datas[0].organic * 100) / datas[0].cnt)),
        Math.floor(((datas[0].fertilizer1 * 100) / datas[0].cnt)),
        Math.floor(((datas[0].fertilizer2 * 100) / datas[0].cnt)),
        Math.floor(((datas[0].lastweed * 100) / datas[0].cnt)),
      ]
    }
    else {
      chartTitle = `0 จำนวน 0 ไร่ `;
      datasets = ifnull;
      datasets_l = ifnull;
      datasets_ll = ifnull;
    }
    //pcplot = ((datachart.cnt * 100) / target).toFixed(1)


    this.dataChart = {
      labels: ['%การงอก(>=95)', 'ระเบิดดินดาน', 'ใส่โดโลไมท์', 'ใส่ปุ๋ยอินทรีย์', 'ใส่ปุ๋ยรอบที่1', 'ใส่ปุ๋ยรอบที่2', 'ไม่มีวัชพืช'],
      datasets: [
        {
          type: 'line',
          //steppedLine: true,
          label: "เป้าหมาย",
          data: datasets,
          fill: false,
          borderColor: '#00ADF9',
          // tension: 0.5,
          yAxisID: "id1",
          order: 1,
          datalabels: {
            color: '#00ADF9',
            acchor: 'end',
            align: 'top',
            offset: 10
          }
        },
        {
          label: "ผลงาน",
          data: datasets_l,
          yAxisID: "id1",
          backgroundColor: [
            'rgba(255, 200, 186, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(153, 102, 255, 0.5)',
            'rgba(144, 252, 173 ,0.5)',
            'rgba(255, 228, 181 ,0.5)',
            'rgba(250, 182, 231 ,0.5)',
            'rgba(186, 225, 255 ,0.5)',
          ],
          order: 0,
          datalabels: {
            color: '#FF0000',
            acchor: 'start',
            align: 'start',
            offset: 5
          },
        },
        {
          type: 'line',
          label: '%ผลงาน',
          yAxisID: "id2",
          data: datasets_ll,
          fill: false,
          borderColor: '#FF9C07',
          tension: 0.05, // เส้นแบบตรง แบบไม่โค้งมน
          pointStyle: 'circle',
          pointRadius: 10,
          pointHoverRadius: 15,
        },
      ],
    };

    this.optionsChart = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          fontSize: 12,
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString()
          }
        },
      },
      //maintainAspectRatio: true,
      title: {
        display: true,
        text: chartTitle,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          //stacked: true,
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{
          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            beginAtZero: false,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            callback: function (value) {
              var ranges = [
                // { divider: 1e3, suffix: 'M' },
                { divider: 1e3, suffix: 'K' }
              ];
              function formatNumber(n) {
                for (var i = 0; i < ranges.length; i++) {
                  if (n >= ranges[i].divider) {
                    return (n / ranges[i].divider).toString() + ranges[i].suffix;
                  }
                }
                return n;
              }
              return /*'$' +*/ formatNumber(value);
            }
          },
          id: "id1" // incorrect property name.
        }, {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            min: Math.min(0),
            max: Math.max(100),
          },
          scaleLabel: { display: true, beginAtZero: true, },
          display: true, // Hopefully don't have to explain this one.
          position: "right",
          gridLines: { display: false },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }

  // กราฟ ประเมินอ้อย
  estimateTypeChart: any;
  estimateCaneChartData: any;
  estimateCaneChartOption: any;
  async Load_estimateCaneChart() {

    this.estimateTypeChart = 'bar';

    let datachart = this.estimateCaneData.filter(el => el.supzone == 'รวม');
    let target: number = this.tarAsNow;
    //console.log('target :', target)

    // target = target.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let pcplot = 0;
    let chartTitle = ''

    datachart = datachart[0]
    // pcplot = ((datachart.cnt*100)/target).toFixed(1)
    chartTitle = `เป้าหมาย ${target} ตัน`

    this.estimateCaneChartData = {

      labels: ['ครั้งที่1', 'ครั้งที่2', 'ครั้งที่3', 'ครั้งที่4', 'ครั้งที่5', 'ครั้งที่6', 'ครั้งที่7', 'ล่าสุด'],
      datasets: [
        {
          label: "ประเมิน",
          data: [
            datachart.As1
            , datachart.As2
            , datachart.As3
            , datachart.As4
            , datachart.As5
            , datachart.As6
            , datachart.As7
            , datachart.As0
          ],
          yAxisID: "id1",
          backgroundColor: [
            'rgba(255, 200, 185, 0.5)',
            'rgba(75, 190, 190, 0.5)',
            'rgba(150, 100, 255, 0.5)',
            'rgba(140, 250, 170 ,0.5)',
            'rgba(255, 220, 180 ,0.5)',
            'rgba(250, 180, 230 ,0.5)',
            'rgba(255, 155, 240 ,0.5)',
            'rgba(50, 160, 255,0.5)',
          ],
          order: 0,
          datalabels: {
            color: '#FF0000',
            acchor: 'start',
            align: 'start',
            offset: 5
          },
        },
        {
          type: 'line',
          label: '%การประเมิน',
          yAxisID: "id2",
          data: [
            Math.floor(((datachart.cnt1 * 100) / datachart.cnt)),
            Math.floor(((datachart.cnt2 * 100) / datachart.cnt)),
            Math.floor(((datachart.cnt3 * 100) / datachart.cnt)),
            Math.floor(((datachart.cnt4 * 100) / datachart.cnt)),
            Math.floor(((datachart.cnt5 * 100) / datachart.cnt)),
            Math.floor(((datachart.cnt6 * 100) / datachart.cnt)),
            Math.floor(((datachart.cnt7 * 100) / datachart.cnt)),
            // Math.floor(((datachart.cnt0 * 100) / datachart.cnt)),
          ],
          fill: false,
          borderColor: '#FF9C07',
          tension: 0.05, // เส้นแบบตรง แบบไม่โค้งมน
          pointStyle: 'circle',
          pointRadius: 10,
          pointHoverRadius: 15,
        },
      ],
    };

    this.estimateCaneChartOption = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          fontSize: 12,
          anchor: 'end',
          align: 'end',
          formatter: function (value, context) {
            return value.toLocaleString();
          },
          id: "id2",
        },
      },
      title: {
        display: true,
        text: chartTitle,
        fontSize: 18
      },
      scales: {
        xAxes: [{
          //stacked: true,
          ticks: {
            fontSize: 14
          },
        }],
        yAxes: [{
          display: true,
          position: 'left',
          scaleLabel: {
            display: true,
            beginAtZero: false,
          },
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            callback: function (value) {
              var ranges = [
                // { divider: 1e3, suffix: 'M' },
                { divider: 1e3, suffix: 'K' }
              ];
              function formatNumber(n) {
                for (var i = 0; i < ranges.length; i++) {
                  if (n >= ranges[i].divider) {
                    return (n / ranges[i].divider).toString() + ranges[i].suffix;
                  }
                }
                return n;
              }
              return formatNumber(value);
            }
          },
          id: "id1"
        }, {
          ticks: {
            fontSize: 14,
            beginAtZero: true,
            min: Math.min(0),
            max: Math.max(100),
          },
          scaleLabel: {
            display: true,
            beginAtZero: true,
          },
          display: true, // Hopefully don't have to explain this one.
          position: "right",
          gridLines: {
            display: false
          },
          id: "id2" // incorrect property name.
        }
        ],
      }
    };
  }

  // กราฟ BRR Model
  brrModelTypeChart: any;
  brrModelChartData: any;
  brrModelChartOption: any;

  async Load_brrModelCaneChart() {
    let data = this.brrsummaryData;
    data.map(elem => this.chartData.push({ name: elem.yearid, value: elem.caneareaPc }));
    console.log('brrsummaryData data :', data)
    let barlabel = data.map(function (elem) { return elem.yearid });
    let barAreadata = data.map((elm => elm.brrModelArea))
    let barTarget = data.map((elm => elm.canearea))
    let barPcArea = data.map((elm => elm.brrModelYield))
    // let ctx = document.getElementById('myChart')
    let chart = new Chart('mixChart', {
      type: "bar",
      data: {
        datasets: [{
          label: 'พท.ปลูก',
          data: barTarget,
          // this dataset is drawn below
          order: 0,
          backgroundColor: 'rgba(255, 0, 0, 0.2)',
          // borderColor: '#2CB2FF',
          borderWidth: 5,
          datalabels: {
            align: 'end',
            anchor: 'start',
            color: '#444',
            formatter: function (value, context) {
              // return value.toLocaleString()
              return Number((value / 1000).toFixed(0)) + 'K';
            },
          },
        }, {
          label: 'พท.BRRModel',
          data: barAreadata,
          yAxisID: "id1",
          order: 1,
          backgroundColor: 'rgba(0,204,0,0.2)',
          borderWidth: 5,
          datalabels: {
            align: 'end',
            anchor: 'center',
            color: '#444',
            formatter: function (value, context) {
              // return value.toLocaleString()
              return Number((value / 1000).toFixed(0)) + 'K';
            },
          },
        }
          , {
          label: 'ผลผลิต',
          data: barPcArea,
          type: 'line',
          fill: false,
          yAxisID: "id2",
          // this dataset is drawn on top
          order: 2,
          borderColor: '#FF9C07',
          // tension: 0.05, // เส้นแบบตรง แบบไม่โค้งมน
          pointStyle: 'circle',
          pointRadius: 10,
          pointHoverRadius: 15,
          datalabels: {
            align: 'end',
            anchor: 'center',
            backgroundColor: '#FF8000',
            borderRadius: 20,
            color: '#000000',
            formatter: function (value, context) {
              return value.toFixed(0)
              // return Number((value / 1000).toFixed(0)) + 'K';
            },
          },
        }],
        labels: barlabel,
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1, // work for mobile 
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return value.toLocaleString()
              // return Number((value / 1000).toString()) + 'K';
              // return value / 1000 + "k";
            },
            // color: '#fff',
            // backgroundColor: '#404040',
            align: 'center',
            anchor: 'center',  // ตำแหน่งข้อมูล
          },
        },
        // คำอธิบายข้อมูล
        legend: {
          display: true,
          position: 'top',
          // จัดรูปแบบของคำอธิบาย
          labels: {
            boxWidth: 10, // ความกว้างของกล่องสีบอกข้อมูล
            padding: 2,
          },
        },
        title: {
          text: "แปลง BRRModel",
          display: false,
          fontSize: 20
        },
        // จัดรูปแบบแกน แนวตั้ง แนวนอน
        scales: {
          xAxes: [{
            stacked: false,  //แท่งแบบต่อกัน 
            ticks: {
              display: true,
              fontSize: 14,
              showLabelBackdrop: true,
              callback: function (value: string, index, ticks) {
                return 'ปี' + value.substr(0, 2) + '/' + value.substr(2, 2)
              }
            },
          }],
          // format แกนตั้ง
          yAxes: [{
            display: true,
            position: 'left',
            // แกนตั้ง ด้านซ้าย
            ticks: {
              // fontSize: 14,
              beginAtZero: true,  // แกนตั้ง 
              // min: Math.min(0),
              // max: Math.max(100),
              // stepSize: 100000,
              // ทำให้แทนที่หลักพันด้วย K
              callback: function (value) {
                var ranges = [
                  { divider: 1e3, suffix: 'K' }
                ];
                function formatNumber(n) {
                  for (var i = 0; i < ranges.length; i++) {
                    if (n >= ranges[i].divider) {
                      return (n / ranges[i].divider).toString() + ranges[i].suffix;
                    }
                  }
                  return n;
                }
                return /*'$' +*/ formatNumber(value);
              }
            },
            id: "id1"
          }, {
            // แกนต้ัง ด้านขวา
            ticks: {
              // fontSize: 14,
              beginAtZero: true,
              min: Math.min(10),
              max: Math.max(20),
            },
            display: true, // Hopefully don't have to explain this one.
            position: "right",
            gridLines: {
              display: false,
            },
            id: "id2" // incorrect property name.
          }
          ],
        }
      }
    });
  }

  // กราฟ การอัพเดตกิจกรรมแปลง ประจำเดือน แบบ ngx-chart
  cpmUpdateData: any = [];
  saleData?: any = [];
  view1?: any = [];
  // กราฟ การอัพเดตกิจกรรมแปลงในแต่ละวันของเดือน แบบ ngx-chart
  async load_cpUpdateMontly() {
    let data = this.cpupdateData;
    data.map(elem => this.saleData.push({ name: elem.mupdate, value: elem.cntPlot }));
    console.log('cpmUpdateData push :', this.cpmUpdateData);
    this.view1 = [650, 500];
  }

  cpupdateDiaryChart?: any;
  async load_cpupdateDiaryMonth() {
    let mname = new Date().toLocaleString('th', { month: 'short', year: 'numeric' })
    let data = this.cpupdateDiaryData;
    let dateinmonth = data.map(function (elem) { return elem.datem });
    let area = data.map(function (elem) { return parseFloat(elem.cntPlot.toFixed(0)) });

    this.cpupdateDiaryChart = new Chart('cpupdataDiary', {
      type: 'line',
      data: {
        labels: dateinmonth,
        datasets: [{
          label: 'จำนวนแปลง',
          data: area,
          datalabels: {
            color: '#ffffff',
            align: 'center',
            offset: 10
          },
          backgroundColor: "#FFD889",
          fill: true,
          //borderColor: "red", // สีของเส้น
          borderWidth: 3,
          borderColor: '#FF9C07',
          pointStyle: 'circle',
          pointRadius: 10,
          pointHoverRadius: 15,
        }]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return value.toLocaleString()
            },
            color: '#fff',
            backgroundColor: '#404040',
          },
        },
        title: { // ข้อความที่อยู่ด้านบนของแผนภูมิ
          text: "การอัพเดตในแต่ละวันของเดือน " + mname,
          display: true,
          fontSize: 20,
        },
      }
    })
  }

  cpUpdateDairyData: any = [];
  async load_cpUpdateDairy() {
    let data: any = []
    data = this.cpupdateData;
    data.map(elem => this.cpUpdateDairyData.push({ name: elem.mupdate, value: elem.cntPlot }));
    // console.log('cpUpdateDairyData push :', this.cpUpdateDairyData);
  }

  // กราฟ การอัพเดตกิจกรรมแปลง ประจำเดือน แบบ ngx-gauge
  gaugeType = "";
  gaugeValue = 0;
  gaugeLabel = "";
  gaugeAppendText = "";
  markerConfig = {
    "0": { color: '#555', size: 8, label: '0', type: 'line' },
    "15": { color: '#555', size: 4, type: 'line' },
    "30": { color: '#555', size: 8, label: '30', type: 'line' },
    "40": { color: '#555', size: 4, type: 'line' },
    "50": { color: '#555', size: 8, label: '50', type: 'line' },
    "60": { color: '#555', size: 4, type: 'line' },
    "70": { color: '#555', size: 8, label: '70', type: 'line' },
    "85": { color: '#555', size: 4, type: 'line' },
    "100": { color: '#555', size: 8, label: '100', type: 'line' },
  }

  // กราฟ  แปลงอ้อย BRR Model
  xChart: any;
  xChartData: any;
  xChartOption: any;
  async load_xChart() {

    this.xChart = 'doughnut';
    let datachart = this.brrsummaryData;
    // console.log('seedratio :', datachart)
    let chartTitle = `แปลงBRR Model ปี ${this.year_S.yearTh}`

    // สุ่มสีของกราฟตาม จำนวนของข้อมูล
    let coloR = []
    let dynamicColors = function () {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      return "rgb(" + r + "," + g + "," + b + ")";
    };
    for (let i in datachart) {
      coloR.push(dynamicColors());
    }

    this.xChartData = {
      labels: datachart.map(row => row.yearid),
      datasets: [
        {
          label: "แปลงBRRModel",
          data: datachart.map(row => row.brrModelArea),
          backgroundColor: coloR,
        },
      ],
    };

    this.xChartOption = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          display: true,
          backgroundColor: '#CCC',
          borderRadius: 3,
          font: {
            color: 'red',
            weight: 'bold',
          },
          formatter: function (value) {
            return `${value.toLocaleString()}`
            // return value;
          },
        },
        doughnutlabel: {
          labels: [
            {
              text: '550',
              font: {
                size: 20,
                weight: 'bold',
              },
            },
            {
              text: 'total',
            },
          ],
        },
      },
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: chartTitle,
        fontSize: 18
      },
    };
  }

  // กราฟแสดงการจัดกลุ่มคิวอ้อย 
  single: any[] = [];;
  view?: any = [];
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  colorScheme = {
    domain: ['#0084ff', '#44bec7', '#ffc300', '#fa3c4c', '#d696bb']
  };

  async drawCpq() {
    this.single = [];
    this.view = [850, 500]
    await this.cpgroupqdata.map(
      elem => this.single.push(
        { name: elem.qdesc, value: parseInt(elem.assess) }
      ));
    // console.log('cpgroup :' ,this.single)
  }

  // test chart
  yTypeChart: any;
  yChartData: any;
  yChartOption: any;
  async load_yChart() {

    this.yTypeChart = 'doughnut';
    let datachart = this.brrsummaryData;
    let chartTitle = `พื้นที่ปลูกอ้อย 4 ปี`
    // สุ่มสีของกราฟตาม จำนวนของข้อมูล
    let coloR = []
    let dynamicColors = function () {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      return "rgb(" + r + "," + g + "," + b + ")";
    };
    for (let i in datachart) {
      coloR.push(dynamicColors());
    }

    this.yChartData = {
      labels: datachart.map(row => row.yearid),
      datasets: [
        {
          label: "พื้นที่ปลูก",
          data: datachart.map(row => row.canearea),
          backgroundColor: coloR,
        },
      ],
    };
    this.yChartOption = {
      responsive: true,
      plugin: [ChartDataLabels],
      plugins: {
        datalabels: {
          formatter: function (value) {
            return ` ${value.toLocaleString()}`
            // return value;
          },
        },
      },
      legend: {
        position: 'right',
      },
      title: {
        display: true,
        text: chartTitle,
        fontSize: 18
      },
    };
  }

  setLabelFormatting(c): string {
    return `${c.label}<br/><span class="custom-label-text">${c.value}</span>`;
  }
  // End KTD Update +++++++++++++++++++++++++++++++++++++++

}
